import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import "fomantic-ui-css/semantic.css";
import "./styles/app.css";
import "./styles/styles.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import numeral from "numeral";
import "numeral/locales/fr";

numeral.locale("fr");

// Supprimer les warnings Semantic UI React (defaultProps, findDOMNode, etc.)
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string") {
    // Ignorer les warnings defaultProps de Semantic UI
    if (args[0].includes("Support for defaultProps will be removed")) return;
    // Ignorer les warnings findDOMNode
    if (args[0].includes("findDOMNode is deprecated")) return;
    // Ignorer les warnings UNSAFE_componentWillMount
    if (args[0].includes("UNSAFE_componentWillMount")) return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
